import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_104: DocMigration = {
  maxSchemaVersion: "0.0.104",
  description: "Fix integrity issues associated with settings/settingsSets/roomLayouts",
  apply(json: any) {
    if (!json.settings) {
      return json;
    }

    // if there are settings present on the doc, settingsSets should be present
    if (!json.settingsSets) {
      json.settingsSets = {};
    }

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      const { parentId } = setting;

      // unreferenced settings are not read by generateSettings and can be safely removed.
      // Creating a settingSet and activating them instead causes regressions.

      if (parentId === undefined) {
        delete json.settings[settingId];
      }

      if (!json.settingsSets[parentId] && !json.rooms?.[parentId]) {
        delete json.settings[settingId];
      }
    }

    if (json.roomLayouts) {
      // if there are roomLayouts present on the doc, rooms should be present
      if (!json.rooms) {
        json.rooms = {};
      }

      for (const roomLayoutId in json.roomLayouts) {
        // unreferenced roomLayouts are not read by generateRoomLayouts and can be safely removed.

        if (!json.rooms[roomLayoutId]) {
          delete json.roomLayouts[roomLayoutId];
        }
      }
    }

    return json;
  },
};

export default migration_0_0_104;
